
import React from 'react';
import { cn } from "@/lib/utils";

interface InterviewActionsProps {
  readingTime?: number; // Made optional since we're not using it anymore
  isBookmarked?: boolean; // Made optional as it's moved to SocialShare
}

const InterviewActions = ({ readingTime, isBookmarked }: InterviewActionsProps) => {
  return (
    <div className="flex items-center gap-4 mb-4 text-sm text-gray-600">
      {/* Component kept for potential future actions */}
    </div>
  );
};

export default InterviewActions;
